import { usePage } from '@inertiajs/react';
import { Box, Group, Progress, rem, Text } from '@mantine/core';

import { MoneyFormatter } from '@/components/MoneyFormatter.jsx';

export default function OfferProgress({ offer, fz = 16, ...props }) {
  const isRegistered = !!usePage().props?.auth?.user;

  return (
    <Box {...props}>
      <Group justify={'space-between'}>
        <Text fz={rem(fz)} c="gfdark.5">
          {isRegistered ? <MoneyFormatter value={offer.total_investment} prefix={offer.price_currency} /> : '$***'}
        </Text>
        <Text fz={rem(fz)} c="gfdark.5">
          {isRegistered ? <MoneyFormatter value={offer.price} prefix={offer.price_currency} /> : '$***'}
        </Text>
      </Group>
      <Progress color="orange" radius={0} value={offer.progress} />
      <Group justify={'space-between'}>
        <Text fw={'bold'} fz={rem(13)} c="gfdark.5">
          FROM {offer.unique_owners} COLLECTORS, {offer.unique_countries} COUNTRIES
        </Text>
        <Text fz={rem(fz)} c="gfdark.5">
          {offer.progress}%
        </Text>
      </Group>
    </Box>
  );
}
